import React, { useCallback } from 'react'
import { FiXCircle } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { Spinner } from 'reactstrap'

import PropTypes from 'prop-types'

import { Button } from '~/components/Buttons'
import Loading from '~/components/Loading'
import useConfirmationModal from '~/hooks/useConfirmationModal'

import useFlyers from '../../hooks/useFlyers'

const CancelButton = ({ data, keepsMenuOpen, menuItem = false }) => {
  const [ConfirmationhModal, showConfirmationModal, toggleConfirmationModal] =
    useConfirmationModal()

  const { handleCancelFlyers } = useFlyers()

  const { loading } = useSelector(
    ({ promotionFlyer }) => promotionFlyer.flyers.update
  )

  const handleToogle = useCallback(() => {
    keepsMenuOpen && keepsMenuOpen(oldState => !oldState)

    toggleConfirmationModal()
  }, [keepsMenuOpen, toggleConfirmationModal])

  const handleSubmit = useCallback(() => {
    const body = {
      data,
      onSuccess: handleToogle
    }

    handleCancelFlyers(body)
  }, [handleCancelFlyers, data, handleToogle])

  return (
    <>
      {menuItem ? (
        <button type="button" onClick={handleToogle} className="danger">
          {loading ? <Spinner /> : <FiXCircle />} <span>Cancelar</span>
        </button>
      ) : (
        <Button
          text="Cancelar"
          type="button"
          template="transparentCritical"
          size="small"
          iconLeft={<FiXCircle />}
          loading={loading}
          customWidth="auto"
          onClick={handleToogle}
        />
      )}

      {/* Modal Cancelar */}
      <ConfirmationhModal
        title="Deseja cancelar o encarte?"
        isOpen={showConfirmationModal}
        onClose={handleToogle}
        onSubmit={handleSubmit}
        confirmationButton="Entendo e desejo cancelar este encarte"
      >
        <p>
          Esta ação não poderá ser desfeita. O encarte permanecerá na listagem e
          poderá ser duplicado no futuro.
        </p>
        {loading && <Loading status={loading}>Cancelando encarte...</Loading>}
      </ConfirmationhModal>
    </>
  )
}

export default CancelButton

CancelButton.propTypes = {
  data: PropTypes.shape({}).isRequired,
  keepsMenuOpen: PropTypes.func,
  menuItem: PropTypes.bool
}

CancelButton.defaultProps = {
  menuItem: false,
  keepsMenuOpen: null
}
